import { render, staticRenderFns } from "./firstSection.vue?vue&type=template&id=09b47226&scoped=true&"
var script = {}
import style0 from "./firstSection.vue?vue&type=style&index=0&id=09b47226&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b47226",
  null
  
)

export default component.exports